export default __webpack_public_path__ + "static/buddy-logo-bbd638db4fc4ece2db673604094f4425.png";